import { OreStack } from '@edenredespana/oreneta'
import { C } from 'vitest/dist/chunks/reporters.d.BFLkQcL6.js'

import {
  AccountingStatusBanner,
  ChangeBankAccountAccessCard,
  ProductsContractingBanner,
} from '@/Contract/ui/molecules'
import { NoBillingPermissionImage } from '@/Home/ui/atoms'
import { AdvertisingSpace } from '@/Home/ui/molecules'
import { InvoicesList } from '@/Invoices/ui/organisms'
import { WebTagPermissionEnum } from '@/Shared/domain'
import { navigationRoutes } from '@/Shared/ui/routers'
import { TpvAccessCard } from '@/Store/ui/molecules'
import { TransactionsList } from '@/Transactions/ui/organisms'
import { useWebTagPermissions } from '@/User/context'
import { useUserData } from '@/User/ui/context'

import { StickerSpace } from '../molecules/StickerSpace'

export const HomeContent = (): JSX.Element => {
  const { hasPermission } = useWebTagPermissions()
  const { merchant } = useUserData()
  const isIndependent = merchant?.isIndependent
  const isNursery = merchant?.isNursery
  const isMasterGroup = merchant?.isMasterGroup
  const isParentCommercial = merchant?.isParentCommercial
  const isChildCommercial = merchant?.isChildCommercial
  const isParentWithHardDependency = merchant?.isParentWithHardDependency
  const isChildWithHardDependency = merchant?.isChildWithHardDependency

  const showRestaurantGroupChild = isChildWithHardDependency && !isIndependent

  const userProducts = merchant?.products || []
  const canAddTpv = hasPermission(WebTagPermissionEnum.ACTION_ADD_TPV)
  const canChangeBankAccount = hasPermission(
    WebTagPermissionEnum.ACTION_BANK_ACCOUNT_CHANGE,
  )
  const canViewBankAccount = hasPermission(WebTagPermissionEnum.VIEW_SHOW_BANK_ACCOUNT)
  const canContractNewProducts = hasPermission(
    WebTagPermissionEnum.ACTION_CONTRACT_NEW_PRODUCTS,
  )
  const needToContractPremiumProduct = !userProducts.some(
    product => product.productCode === 33,
  )
  const restaurantIndependentAdmin =
    isIndependent && !isNursery && canChangeBankAccount && canContractNewProducts
  const restaurantIndependentVisor =
    isIndependent && !isNursery && !canChangeBankAccount && !canContractNewProducts
  const showProductsContractingBanner =
    canContractNewProducts && isIndependent && needToContractPremiumProduct

  const allowRequestMaterial = hasPermission(WebTagPermissionEnum.ACTION_REQUEST_MATERIAL)
  const showInvoicesList = hasPermission(WebTagPermissionEnum.VIEW_SHOW_INVOICES)
  const restaurantSAdmin = hasPermission(WebTagPermissionEnum.ACTION_LOCAL_DATA_CHANGE)

  // Condiciones de visibilidad de los componentes del home
  const showRestaurantGroupParents =
    (isParentCommercial || isChildCommercial || isParentWithHardDependency) &&
    !isIndependent &&
    !isNursery
  const restaurantGroupAdmin =
    showRestaurantGroupParents && canAddTpv && canChangeBankAccount && restaurantSAdmin
  const restaurantGroupVisor =
    showRestaurantGroupParents && !restaurantSAdmin && canViewBankAccount
  const restaurantChildDependencyAdmin =
    isChildWithHardDependency && !isIndependent && !isNursery && restaurantSAdmin
  const restaurantChildDependencyVisor =
    isChildWithHardDependency && !isIndependent && !isNursery && !restaurantSAdmin

  return (
    <>
      <OreStack space="xlarge" placeContent="stretch">
        {/* RESTAURANTES */}
        {(showProductsContractingBanner ||
          restaurantGroupAdmin ||
          restaurantIndependentAdmin) &&
          needToContractPremiumProduct && (
            <ProductsContractingBanner origin={navigationRoutes.home} />
          )}
        {canChangeBankAccount && (
          <AccountingStatusBanner origin={navigationRoutes.home} />
        )}
        {(restaurantGroupAdmin || restaurantIndependentAdmin) && (
          <OreStack space="xlarge" direction="row" sameSize>
            <ChangeBankAccountAccessCard origin={navigationRoutes.home} />
            <TpvAccessCard />
          </OreStack>
        )}
        {(restaurantGroupVisor ||
          restaurantChildDependencyAdmin ||
          restaurantChildDependencyVisor ||
          restaurantIndependentVisor) && (
          <OreStack space="xlarge" direction="row">
            <TpvAccessCard />
            <NoBillingPermissionImage isNursery={merchant?.isNursery ? true : false} />
          </OreStack>
        )}
        {/* GUARDERIAS */}
        {/* Aqui la comprobación de visor o admin se realiza dentro de cada compomente */}
        {isNursery &&
          (isParentCommercial ||
            isChildCommercial ||
            isParentWithHardDependency ||
            isIndependent) && (
            <OreStack space="xlarge" direction="row" placeContent="stretch">
              <div style={{ width: '543.13px' }}>
                <ChangeBankAccountAccessCard origin={navigationRoutes.home} />
              </div>
              <NoBillingPermissionImage isNursery={isNursery ? true : false} />
            </OreStack>
          )}
        {isNursery && isChildWithHardDependency && allowRequestMaterial && (
          <>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                gap: '3rem',
                alignItems: 'flex-start',
              }}
            >
              <StickerSpace origin={navigationRoutes.home} />
              <NoBillingPermissionImage isNursery={isNursery ? true : false} />
            </div>
            <TransactionsList isHome />
          </>
        )}
        {isNursery && isChildWithHardDependency && allowRequestMaterial && <></>}

        {showInvoicesList ? <InvoicesList isHome /> : null}
        {!isNursery ? <AdvertisingSpace hasPermission={hasPermission} /> : null}

        {isNursery &&
        isChildWithHardDependency &&
        !isIndependent &&
        !allowRequestMaterial ? (
          <TransactionsList isHome />
        ) : null}
        {/* {isChildWithHardDependency && isIndependent ? <TransactionsList isHome /> : null} */}
      </OreStack>
    </>
  )
}
